import { filterOptions } from '@/utils/query-base'

const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export const pageSearch = {
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: city,
    dictionary: 'A0002',
    width: 180,
    // 默认值由字典 defQuery_planType 动态加载
  },
  'cust_name': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250,
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: city
  },
}

export default {
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'cust_name': {
    title: '客户名称',
    width: 250,
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'plan_type_text': {
    title: '计划类型',
    width: 180
  },
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },

  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019'
  },
  'gjahr': {
    title: '年度',
    // type: 'year',
    // equation: city
  },
  'total_qty01': {
    title: '1月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty01': {
    title: '1月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa01': {
    title: '1月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty01': {
    title: '1月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty01': {
    title: '1月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty01': {
    title: '1月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo01': {
    title: '1月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt01': {
    title: '1月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt01': {
    title: '1月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt01': {
    title: '1月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt01': {
    title: '1月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt01': {
    title: '1月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo01': {
    title: '1月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty02': {
    title: '2月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty02': {
    title: '2月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa02': {
    title: '2月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty02': {
    title: '2月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty02': {
    title: '2月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty02': {
    title: '2月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo02': {
    title: '2月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt02': {
    title: '2月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt02': {
    title: '2月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt02': {
    title: '2月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt02': {
    title: '2月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt02': {
    title: '2月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo02': {
    title: '2月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty03': {
    title: '3月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty03': {
    title: '3月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa03': {
    title: '3月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty03': {
    title: '3月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty03': {
    title: '3月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty03': {
    title: '3月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo03': {
    title: '3月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt03': {
    title: '3月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt03': {
    title: '3月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt03': {
    title: '3月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt03': {
    title: '3月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt03': {
    title: '3月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo03': {
    title: '3月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty04': {
    title: '4月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty04': {
    title: '4月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa04': {
    title: '4月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty04': {
    title: '4月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty04': {
    title: '4月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty04': {
    title: '4月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo04': {
    title: '4月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt04': {
    title: '4月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt04': {
    title: '4月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt04': {
    title: '4月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt04': {
    title: '4月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt04': {
    title: '4月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo04': {
    title: '4月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty05': {
    title: '5月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty05': {
    title: '5月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa05': {
    title: '5月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty05': {
    title: '5月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty05': {
    title: '5月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty05': {
    title: '5月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo05': {
    title: '5月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt05': {
    title: '5月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt05': {
    title: '5月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt05': {
    title: '5月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt05': {
    title: '5月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt05': {
    title: '5月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo05': {
    title: '5月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty06': {
    title: '6月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty06': {
    title: '6月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa06': {
    title: '6月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty06': {
    title: '6月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty06': {
    title: '6月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty06': {
    title: '6月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo06': {
    title: '6月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt06': {
    title: '6月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt06': {
    title: '6月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt06': {
    title: '6月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt06': {
    title: '6月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt06': {
    title: '6月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo06': {
    title: '6月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty07': {
    title: '7月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty07': {
    title: '7月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa07': {
    title: '7月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty07': {
    title: '7月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty07': {
    title: '7月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty07': {
    title: '7月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo07': {
    title: '7月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt07': {
    title: '7月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt07': {
    title: '7月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt07': {
    title: '7月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt07': {
    title: '7月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt07': {
    title: '7月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo07': {
    title: '7月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty08': {
    title: '8月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty08': {
    title: '8月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa08': {
    title: '8月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty08': {
    title: '8月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty08': {
    title: '8月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty08': {
    title: '8月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo08': {
    title: '8月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt08': {
    title: '8月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt08': {
    title: '8月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt08': {
    title: '8月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt08': {
    title: '8月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt08': {
    title: '8月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo08': {
    title: '8月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty09': {
    title: '9月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty09': {
    title: '9月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa09': {
    title: '9月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty09': {
    title: '9月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty09': {
    title: '9月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty09': {
    title: '9月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo09': {
    title: '9月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt09': {
    title: '9月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt09': {
    title: '9月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt09': {
    title: '9月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt09': {
    title: '9月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt09': {
    title: '9月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo09': {
    title: '9月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty10': {
    title: '10月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty10': {
    title: '10月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa10': {
    title: '10月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty10': {
    title: '10月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty10': {
    title: '10月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty10': {
    title: '10月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo10': {
    title: '10月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt10': {
    title: '10月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt10': {
    title: '10月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt10': {
    title: '10月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt10': {
    title: '10月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt10': {
    title: '10月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo10': {
    title: '10月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty11': {
    title: '11月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty11': {
    title: '11月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa11': {
    title: '11月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty11': {
    title: '11月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty11': {
    title: '11月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty11': {
    title: '11月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo11': {
    title: '11月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt11': {
    title: '11月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt11': {
    title: '11月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt11': {
    title: '11月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt11': {
    title: '11月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt11': {
    title: '11月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo11': {
    title: '11月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty12': {
    title: '12月份总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty12': {
    title: '12月份初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_sa12': {
    title: '12月份战区调整量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty12': {
    title: '12月份已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty12': {
    title: '12月份已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty12': {
    title: '12月份剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo12': {
    title: '12月份月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt12': {
    title: '12月份总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt12': {
    title: '12月份初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt12': {
    title: '12月份已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt12': {
    title: '12月份已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt12': {
    title: '12月份剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo12': {
    title: '12月份月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_qty_year': {
    title: '全年总计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_qty_year': {
    title: '全年初始计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_qty_year': {
    title: '全年已占用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_qty_year': {
    title: '全年已开票计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_qty_year': {
    title: '全年剩余可用计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_qty_mo_year': {
    title: '全年月末调整计划量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'total_amt_year': {
    title: '全年总计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'initplan_amt_year': {
    title: '全年初始计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'atp_amt_year': {
    title: '全年已占用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'billing_amt_year': {
    title: '全年已开票计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'remain_amt_year': {
    title: '全年剩余可用计划额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'adjust_amt_mo_year': {
    title: '全年月末调整计划额',
    xlsxFmt: {
      t: 'n'
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/sale-plan-manage/config/salePlanCountList.js